import CustomFile from 'components/file/CustomFile'
import CustomIcon from 'components/icon/CustomIcon'
import { useState } from 'react'

import styled from 'styled-components'
import { FixMeLater } from 'types'
import { IUserData } from 'types/user.types'
import colors from 'utils/colors'
import { convertTextForInitialInputData } from 'utils/helpers/messageHelper'
import { icons } from 'utils/icons'
import CommonInput from '../_components/common-input/CommonInput'
import PostHeader from '../_components/post-header/PostHeader'
import { TextBox } from '@progress/kendo-react-inputs'
import { useTranslation } from 'react-i18next'
import { POST } from 'locales/locales'

interface IContentProps {
  data: {
    header:string;
    text: string
    files: FixMeLater[]
    mentionedUsers: Array<string>
  }
  commentToggle: boolean;
  users: IUserData
  placeHolder: string
  avatar: string
  fullname: string
  isValidEditPost: boolean
  isPostLoading: boolean
  header:string
  isComment:boolean
  onChangeInputHeader:(e:FixMeLater) => void,
  onClose: () => void
  onCancelFile: (index: number) => void
  onChangeText: (text: string) => void
  onEmojiClick: (emojiData: FixMeLater) => void
  onEditPost: () => void
}

const Content = ({
  data,
  users,
  placeHolder,
  avatar,
  fullname,
  isValidEditPost,
  isPostLoading,
  header,
  isComment,
  onChangeInputHeader,
  onClose,
  onCancelFile,
  onChangeText,
  onEmojiClick,
  onEditPost,
}: IContentProps) => {

  const { t } = useTranslation()
  const initialInputData = convertTextForInitialInputData(data, users)
  const [mentionsDropdown, setMentionsDropdown] = useState(false)

  // Presigned URL'li dosya listesi
  const filesWithPresigned = data?.files || [];

  const handleOnChange = (text: string) => {
    onChangeText(text)
  }

  const emojiHandler = (emojiData: FixMeLater) => {
    onEmojiClick(emojiData)
  }

  const onKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (mentionsDropdown) return;

    event.key === 'Enter' && !event.shiftKey && event.preventDefault()

    if (
      event.key === 'Enter' &&
      isValidEditPost &&
      !event.shiftKey &&
      !mentionsDropdown &&
      !isPostLoading
    ) {
      onEditPost()
      onClose()
    }
  }

  return (
    <Wrapper>
      <PostHeader avatar={avatar} fullname={fullname} />
      {!isComment && (
        <div style={{ marginTop: '10px' }}>
          <TextBox
            value={header}
            onChange={onChangeInputHeader}
            style={{ fontSize: 16, borderRadius: 25, padding: '6px 10px'}}
            placeholder={t(POST.ENTER_A_HEADER)}
            required={true}
          />
        </div>
      )}

      <CommonInput
        id={'common_edit_input'}
        textInfo
        data={initialInputData}
        placeHolder={placeHolder}
        onKeyDown={onKeyDown}
        onSelectEmoji={emojiHandler}
        onMentionDropDown={setMentionsDropdown}
        onChangeInputData={handleOnChange}
      />
      {filesWithPresigned.length > 0 && (
        <Layout onClick={(event) => event.stopPropagation()}>
          {filesWithPresigned.map((file: FixMeLater, index: number) => {
            let url = '';
            if (file.url) {
              url = file.url;
            } else if (file instanceof File || file instanceof Blob) {
              url = URL.createObjectURL(file);
            }
            const name = file.originalName || file.name
            const mimetype = file?.mimetype || file?.type
            const size = file?.size
            return (
              <FileMessageWrapper key={file?._id || file?.lastModified}>
                <CloseIcon
                  id="cancel-file"
                  iconPreset="small"
                  source={icons.closeIconWhite}
                  isCancel={false}
                  onClick={() => onCancelFile(file)}
                />
                <CustomFile
                  index={index}
                  files={data.files}
                  sentAt={file.sentAt}
                  source={url}
                  mimetype={mimetype}
                  preset={'postInput'}
                  size={size}
                  filename={name}
                  thumbnail={file?.thumbnail}
                />
              </FileMessageWrapper>
            )
          })}
        </Layout>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div``

const Layout = styled.div`
  margin-bottom: 16px;
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`
const FileMessageWrapper = styled.div`
  position: relative;
  #cancel-file {
    display: flex;
  }
  #loading-file {
    display: none;
  }
  max-width: 120px;
  max-height: 90px;
`

const CloseIcon = styled(CustomIcon).attrs((props: { isCancel: boolean }) => props)`
  display: ${({ isCancel }) => (isCancel ? 'flex' : 'none')};
  position: absolute;
  top: -5px;
  right: -5px;
  flex-shrink: 0;
  background-color: ${colors.vime};
  border-radius: 50%;

  align-items: center;
  justify-content: center;
  z-index: 2;
`

export default Content
